import React from 'react';
import i18n from '../i18n';
import reportError from '../helpers/reportError';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        reportError({
            message: error.message,
            stack: error.stack,
            componentStack: errorInfo.componentStack,
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '2rem', textAlign: 'center', color: '#999' }}>
                    <h2>{i18n.t('errors.somethingWentWrong')}</h2>
                    <p>{i18n.t('errors.refreshPage')}</p>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
